import enLocale from 'element-ui/lib/locale/lang/en';

export default {
  localeName: 'English',
  welcome: {
    welcomeMessage: 'Welcome to Foodie!',
    appVersion: 'v{version}',
    appDescription: 'Food management for Wizeline',
    loginButton: 'Log in to start saving food!',
    logoutButton: 'Logout',
    notFound: 'Page not found!',
    notFoundButton: 'Get back to the home page',
    messages: {
      userFetchError: 'There was a problem retrieving your user info.',
    },
  },
  settings: {
    settingTitle: 'Settings',
    officeHeader: 'Where are you based?',
    catering: {
      settingTitle: 'Station setup',
      officeHeader: 'Select the office',
      dietsHeader: 'Select the type of meals being served in this station',
      mealHeader: 'Select the meal being served',
      pinCodeHeader: 'Insert PIN code to access and edit the settings for this meal station.',
      bodyMessage:
        'You can edit the date, the office, dietary options being served, and meal being served. If you have any problems, please contact @Vane DLA or @elbz',
      saveButton: 'Finish station setup',
      pinCodeLabel: 'Enter the 4 digit PIN code',
      pinCodePH: 'XXXX',
      pinCodeSubmit: 'Done',
      dateHeader: 'Current day',
    },
    dropDownPlaceholder: 'Select',
    dietTypeHeader: 'Dietary Options',
    allergiesHeader: 'Allergies',
    saveButton: 'Save',
    messages: {
      checkBoxSuccess: 'Dietary option saved correctly',
      checkBoxFail: 'Dietary option was not saved correctly',
      officeDropDownSuccess: 'Office option saved correctly',
      officeDropDownFail: 'Office option was not saved correctly',
      saveButtonSuccess: 'Your settings were saved correctly',
      saveButtonFail: 'Your settings were not saved',
      settingsSaved: 'Station settings were saved correctly',
      incorrectPinCode:
        'Incorrect PIN code! Please try again or contact @Vane DLA / @elbz for assistance',
      cateringSettingsError:
        "Settings were not saved. If you're having trouble, please try again or contact @Vane DLA / @elbz for assistance",
    },
    checkboxes: {
      regularLabel: 'Regular',
      lightLabel: 'Light',
      veganLabel: 'Vegan',
      vegetarianLabel: 'Vegetarian',
      extrasLabel: 'Extras',
      grillLabel: 'Grill',
      includedLabel: 'included',
      regularDescription: 'No restrictions; includes all food groups',
      lightDescription: 'Lower in calories, sugar, and fat',
      vegetarianDescription: 'Excludes meat, but includes some animal products',
      veganDescription: 'No animal products',
      grillDescription: 'Grilled food',
      extrasDescription: 'Can include desserts, side dishes, salads, and others',
      restaurantLabel: 'Restaurant',
      restaurantDescription: 'Order directly in restaurant',
    },
    fillInvite: {
      header: 'Are you inviting someone over? Let us know!',
      button: 'Fill invite',
    },
  },
  calendar: {
    to: 'to',
    saveButton: 'Send my order',
    mondayTitle: 'Monday',
    tuesdayTitle: 'Tuesday',
    wednesdayTitle: 'Wednesday',
    thursdayTitle: 'Thursday',
    fridayTitle: 'Friday',
    eventBreakfast: 'Breakfast',
    eventLunch: 'Lunch',
    eventName: 'Event',
    noMealBreakfast: 'No breakfast this day',
    noMealLunch: 'No lunch this day',
    noMeals: 'No meals',
    noDiets:
      'No dietary options available, please double check your settings or ask for assistance with the facilities team.',
    holidayMeals:
      'This might be a holiday in your office. Please check with your office manager to confirm.',
    lunchNoMenu: 'No menu available yet. Don’t worry, the Facilities team won’t let you go hungry!',
    messages: {
      insertOrderFail: 'Order was not saved',
      insertOrderSuccess: 'Order saved successfully',
      removeMealFail: 'Meal was not removed',
      removeMealSuccess: 'Meal removed',
      removeMealDayFail: 'Day meals were not removed',
      removeMealDaySuccess: 'Day meals removed',
      removeMealEventFail: 'Event meals were not removed',
      removeMealEventSuccess: 'Event meals removed',
      removeMealWeekFail: 'Week meals were not removed',
      removeMealWeekSuccess: 'Week meals removed',
      updateOrderSuccess: 'Order updated successfully',
      updateOrderFail: 'Order was not updated',
    },
    unableToFetchEvents: 'Unable to fetch the meal events. Please refresh the page to retry.',
    noMealCheckboxes: {
      all: 'No meals this week',
      breakfast: 'No breakfast this week',
      lunch: 'No lunch this week',
    },
    noMealWarnings: {
      all: 'Warning! All the meals you selected will be erased.',
      event: 'Warning! The meals you selected for {event} will be erased.',
      message: 'You will have to select them again if you want them. <br> Are you sure about this?',
      buttonDeny: 'Nevermind',
      buttonAccept: 'Yes, erase my order',
    },
  },
  orders: {
    tabs: {
      uploadMenuTitle: 'Upload Menu',
      totalsTitle: 'Totals',
      individualListTitle: 'Individual List',
      totalsByUsersTitle: 'Totals By User',
      userUploaderTitle: 'Upload Users',
      orderUploaderTitle: 'Upload Orders',
    },
  },
  orderReport: {
    locations: 'Location',
    ordersFor: 'Orders for',
    to: 'to',
    export: 'Export',
    exportHint: 'Export report',
    breakfast: 'Breakfast',
    breakfast_extras: 'Extras',
    lunch: 'Lunch',
    lunch_extras: 'Extras',
    extras: 'Extras',
    regular: 'Regular',
    grill: 'Grill',
    light: 'Light',
    vegetarian: 'Vegetarian',
    vegan: 'Vegan',
    lactoseFree: 'Lactose free',
    restaurant: 'Restaurant',
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    week: 'Week',
    dailyTotals: 'Daily Totals',
    weeklyTotals: 'Weekly Totals',
    totals: 'Totals',
    summaryTitle: 'Grand Total',
    summaryColumn: 'Total',
    eventTitle: 'Event',
    mealTitle: 'Meal',
    dietTitle: 'Diet',
    weekTitle: 'Week',
    totalTitle: 'Total',
    totalFor: 'Total for',
    loading: 'Loading Totals...',
  },
  orderList: {
    location: 'Location',
    ordersFor: 'Orders for',
    to: 'to',
    export: 'Export',
    exportHint: 'Export report',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    extras: 'Extras',
    regular: 'Regular',
    grill: 'Grill',
    light: 'Light',
    vegetarian: 'Vegetarian',
    vegan: 'Vegan',
    restaurant: 'Restaurant',
    lactoseFree: 'Lactose free',
    holidayWarningStart: 'A total of  ',
    holidayWarningEnd: ' meals were removed from the report because they were considered Holidays',
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
    },
    email: 'Email',
    description: 'List of orders within a range of time',
    loading: 'Loading Individual List...',
    total: 'Total',
    selectDateRange: 'Select Date Range',
    nameUser: 'Name',
    bambooId: 'Bamboo Id',
    uploadHint: 'Upload CSV File',
    uploadBambooIds: 'Bamboo Ids',
  },
  uploadMenu: {
    locations: 'Location',
    descriptionTitle: 'To upload a menu to Foodie, follow the next steps:',
    description: `<ol>
    <li>Click the <b>Template</b> button. Then, the Wizeline template gallery window appears.</li>
    <li>In the <b>Template gallery</b>, select the menu template that corresponds to your office. A Google Sheets file with the menu template opens.</li>
    <li>In the file, fill the template cells with the weekly menu information.</li>
    <b>Note:</b> Delete any row or column that includes no information.<br />
    <b>Important:</b> Be sure to enter the correct dates for each day in the template.<br />
    <li>Download the menu file as tab-separated values (<tt>.tsv</tt>). To do so, perform the following steps:</li>
    <ol type="a">
    <li>At the top left part of the screen, click the <b>File</b> button. A drop-down list appears.</li>
    <li>In the drop-down list, hover your cursor over the <b>Download as</b> option. A drop-down sub-list appears to the right.</li>
    <li>In the side sub-list, click the <b>Tab-separated values (.tsv, current sheet)</b> option.</li>
    </ol>
    <li>In this window, click the <b>Upload</b> button. A Finder pop-up window appears.</li>
    <li>In the pop-up window, select the <tt>.tsv</tt> menu file you downloaded in step 4.</li>
    <li>Click the <b>Open</b> button in the pop-up menu. The menu file is now uploaded.</li>
    </ol>`,
    template: 'Template',
    templateHint: 'Open template',
    upload: 'Upload',
    uploadHint: 'Upload .tsv',
  },
  uploadUsers: {
    locations: 'Location',
    descriptionTitle: 'To upload users to Foodie, follow the next steps:',
    description: `<ol>
    <li>Click the <b>BambooHR</b> button to download the latest export of users from BambooHR.</li>
    <b>Note:</b> Log in using your <b>Okta credentials</b> if requested.<br />
    <li>Click the <b>Upload</b> button. A Finder pop-up window appears.</li>
    <li>In the pop-up window, select the <tt>.csv</tt> file you downloaded.</li>
    <li>Click the <b>Open</b> button in the pop-up menu. The menu file is now uploaded.</li>
    </ol>`,
    template: 'BambooHR',
    templateHint: 'Export Users from Bamboo',
    upload: 'Upload',
    uploadHint: 'Upload exported .csv',
  },
  uploadOrders: {
    locations: 'Location',
    descriptionTitle: 'To upload orders to Foodie, follow the next steps:',
    description: `<ol>
    <li>Click the <b>Template</b> button. Then, the Wizeline template gallery window appears.</li>
    <li>In the file, fill the template cells with the orders information.</li>
    <b>Important:</b> Be sure to enter the correct dates for each day in the template.<br />
    <li>Download the menu file as tabs-separated values (<tt>.tsv</tt>). To do so, perform the following steps:</li>
    <ol type="a">
    <li>At the top left part of the screen, click the <b>File</b> button. A drop-down list appears.</li>
    <li>In the drop-down list, hover your cursor over the <b>Download as</b> option. A drop-down sub-list appears to the right.</li>
    <li>In the side sub-list, click the <b>Tabs-separated values (.tsv, current sheet)</b> option.</li>
    </ol>
    <li>Click the <b>Upload</b> button. A Finder pop-up window appears.</li>
    <li>In the pop-up window, select the <tt>.tsv</tt> file you downloaded.</li>
    <li>Click the <b>Open</b> button in the pop-up menu. The orders file is now uploaded.</li>
    </ol>`,
    template: 'Orders list',
    templateHint: 'Open template',
    upload: 'Upload',
    uploadHint: 'Upload .tsv',
  },
  navBar: {
    menuButton: 'Menu',
    settingsButton: 'Settings',
    reportsButton: 'Reports',
    notificationsButton: 'Notifications',
    orderButton: 'Orders',
    adminButton: 'Admin',
  },
  footer: {
    copyright: 'Copyright',
    messageBold: 'We want to make Foodie better.',
    message:
      'Do you have a bug to report or a new feature to request? Problems with the meals? Let us know!',
    takeSurveyAction: 'Bugs or Features',
    takeCateringSurveyAction: 'Meals feedback',
  },
  firstLogin: {
    modalTitle: 'Welcome to Foodie!',
    headerModal: 'Before we get started we would like to know you better:',
    officeTitle: 'Where are you typically located?',
    menuTitle: 'Which menu do you typically choose?',
    eventsTitle: 'Which meals do you typically have at the office?',
    modalFooter: 'If anything changes, you can edit this information later in the Settings section',
    saveButton: 'Save',
  },
  admin: {
    adminPageTitle: 'Weekly Menu Order',
    officeDropdownHeader: 'Choose an office',
    uploadFileHeader: 'Upload file',
    uploadFileButton: 'Upload',
    uploadFileDescription: '.tsv file',
    exceededFileLimitMessage: 'You may only upload 1 file',
    beforeRemoveFileMessage: 'Are you sure you want to delete this file from the uploader?',
    menuParserMessages: {
      minDataRows: 'Invalid file format: It must contain at least 4 rows',
      minDataColumns: 'Invalid file format: It must contain at least 3 columns',
      dateFormat: "Invalid date format: The date should have 'yyyy-mm-dd' format",
      firstRowFormat: "Invalid file format: First row should begin with 'Catering' as first field",
      thirdRowFormat: "Invalid file format: Third row should begin with 'Event' as first field",
      noMeal: 'Invalid content: you must fill all the meal fields',
      successUpload: 'File uploaded successfully',
      errorUpload: 'File failed to upload',
    },
    orderParserMessages: {
      minDataRows: 'Invalid file format: It must contain at least 4 rows',
      minDataColumns: 'Invalid file format: It must contain at least 4 columns',
      dateFormat: "Invalid date format: The date should have 'yyyy-mm-dd' format",
      firstRowFormat: "Invalid file format: First row should begin with 'Catering' as first field",
      thirdRowFormat: "Invalid file format: Third row should begin with 'Event' as first field",
      fourthRowFormat: "Invalid file format: Third row should begin with 'Email' as second field",
      fifthRowFormat: "Invalid file format: Third row should begin with 'Name' as third field",
      noMeal: 'Invalid content: you must fill all the meal fields',
      successUpload: 'File uploaded successfully',
      errorUpload: 'File failed to upload',
    },
    repeatedMenuMessageBoxText:
      'A weekly menu with the same date () already exists. Do you want to replace it?',
    repeatedMenuMessageBoxConfirmButton: 'Yes, replace file',
    repeatedMenuMessageBoxCancelButton: 'Cancel',
    repeatedMenuMessageBoxSuccess: 'Weekly menu replaced',
    repeatedMenuMessageBoxInfo: 'Weekly menu was not replaced',
    repeatedMenuText: 'Replace',
  },
  catering: {
    cateringPageTitle: 'Hello! Happy to have you here.',
    userSearchTitle: 'Start typing to search by name',
    searchPlaceholder: 'Start typing',
    allDietTypes: 'All types',
    or: 'or',
    qr: 'Tap to scan your personal QR code here',
    contact: 'If you have any issues, contact {cateringContact}',
    email: 'Email',
    name: 'Name',
    order: 'Order',
    served: 'Assisted',
    notAssisted: 'Not Assisted',
    type: 'Type',
    totals: 'Totals',
    total: 'Total',
    messages: {
      incorrectOffice: `Incorrect office`,
      incorrectMeal: `No meal for this day`,
      incorrectStation: `Incorrect station, you ordered {userOrder}`,
      orderSuccess: `Order has been found`,
      orderError: `orderError: we don't know what happened`,
      orderAlreadyServed: 'Meal already served',
    },
    confirmationModal: {
      success: {
        title: 'Bon appétit!',
        message: 'Wohoo! Please pick up your {mealType} menu',
        confirmationAction: 'Thanks!',
      },
      userNotInTheList: {
        title: 'Please contact the Facilities team',
        message: 'Uh-oh! Your name is not registered in Foodie.',
        confirmationAction: 'Got it',
      },
      incorrectMealType: {
        title: 'Go to the correct station',
        message: 'Oops! You asked for {mealType} menu!',
        confirmationAction: 'Got it',
      },
      notRegisteredMeals: {
        title: 'Please contact the Facilities team',
        message: 'Uh-oh! Looks like there are no registered meals for you.',
        confirmationAction: 'Got it',
      },
      mealAlreadyServed: {
        title: 'Your food has been already served',
        message:
          'Uh-oh! Looks like you already picked your {mealType} menu. Please wait a bit for a second plate!',
        confirmationAction: 'Got it',
      },
      wrongOffice: {
        title: 'Please go to #foodie-gdl or contact Facilities Team',
        message: 'Uh-oh! Looks like you ordered at {office}',
        confirmationAction: 'Got it',
      },
    },
  },
  modalSessionExpired: {
    message: 'Session expired. Please log in again',
    acceptBtnMssg: 'Accept',
  },

  deadlineTimeBanner: {
    message:
      "Hi, there! Meal submission closed on {dueDay} at {dueHour} and will be available on {startDay} at {startHour} (all times are 'America/Mexico_City'). Please contact facilities team for help.",
    dismissButton: 'Dismiss',
  },

  weeklyMenuPage: {
    modal: {
      failureTitle: 'Oops! An error occurred while saving your meals.',
      failureMessage: 'Please recheck your order and try saving again.',
      successTitle: '',
      successMessage: 'Your order has been sent!',
    },
    messages: {
      menuFetchError: 'There was an error fetching the menu information',
    },
  },
  accessKeys: {
    modal: {
      title: 'Shortcuts',
      instructions:
        'Enjoy this new - and fast! - way to navigate inside Foodie with the following shortcuts. We’re eager to listen how you like them!',
      listTitle: 'These are the vailable shortcuts:',
      listOfAccessKeys: {
        navbar: 'Navigation bar',
        accessKeysModal: 'Access keys button',
        home: 'Home',
        settings: 'Settings',
        reports: 'Reports',
        logout: 'Logout',
        weekNav: 'Week navigation',
        previousweek: 'Previous week',
        nextweek: 'Next week',
        noMealsInWeekByEventShortcuts: 'No meals in week',
        meals: 'Meals',
        breakfast: 'Breakfast',
        lunch: 'Lunch',
        weekDays: 'Week days',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        dietaryOptionsFilter: 'Dietary options filter',
        regular: 'Regular',
        grill: 'Grill',
        light: 'Light',
        vegan: 'Vegan',
        vegetarian: 'Vegetarian',
        extras: 'Extras',
        menu: 'Menu',
        none: 'None',
        sendOrder: 'Send order',
        restaurant: 'Restaurant',
      },
    },
    displayListOfAccessKeysButton: 'Learn your shortcuts!',
  },
  global: {
    company: 'Company',
  },
  companiesFilter: {
    wizeline: 'Wizeline',
    gravity: 'Gravity',
    all: 'All',
  },
  reports: {
    myOrders: {
      title: 'My orders',
      orders: 'You ordered',
      mealsFrom: 'meal(s) from',
      mealsTo: 'to',
    },
  },
  ...enLocale,
};



// WEBPACK FOOTER //
// ./src/i18n/messages/en.js